<template>
  <mall-fixed-bar class="mall-fixed-button-bar">
    <button type="button" class="mall-fixed-button-bar__button" @click="handleClick" v-if="text">
      {{ text }}
    </button>
  </mall-fixed-bar>
</template>

<script>
import MallFixedBar from './FixedBar';

export default {
  name: 'MallFixedButtonBar',

  components: {
    MallFixedBar
  },

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss">
.mall-fixed-button-bar {
  .mall-fixed-bar__bd {
    padding: 8px 32px;
    background-color: #f8f8f8;
  }

  .mall-fixed-button-bar__button {
    width: 100%;
    height: 48px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    line-height: 1;
    background-image: linear-gradient(-45deg, #ff2959 0%, #ff3c3c 100%);
    border: 0;
    border-radius: 10000px;
  }
}
</style>
